import * as React from 'react';

interface Props {
  endsAt: number;
  clockOffset?: number;
  onEnd?: () => void;
  compact?: boolean;
}

export default function Countdown({ endsAt, clockOffset = 0, onEnd, compact = false }: Props) {
  const [remaining, setRemaining] = React.useState(Math.max(0, endsAt - Date.now() - clockOffset));
  React.useEffect(() => {
    const tick = () => setRemaining(Math.max(0, endsAt - Date.now() - clockOffset));
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [endsAt, clockOffset]);
  React.useEffect(() => {
    if (remaining === 0) onEnd?.();
  }, [onEnd, remaining]);
  const seconds = Math.floor(remaining / 1000);
  const values = [
    [Math.floor(seconds / 86400), 'd'],
    [Math.floor((seconds % 86400) / 3600), 'h'],
    [Math.floor((seconds % 3600) / 60), 'm'],
    [seconds % 60, 's'],
  ];
  return (
    <span
      className="inline-flex gap-1 font-mono tabular-nums"
      aria-label={`Sale ends ${new Date(endsAt).toLocaleString()}`}
    >
      <span className="sr-only">Sale ends {new Date(endsAt).toLocaleString()}</span>
      {(compact ? values.slice(0, 3) : values).map(([value, label]) => (
        <span
          key={label}
          aria-hidden="true"
          className="rounded-md border border-emerald-300/20 bg-black/20 px-1.5 py-1 text-xs text-emerald-100"
        >
          {String(value).padStart(2, '0')}
          <span className="ml-0.5 text-emerald-200/65">{label}</span>
        </span>
      ))}
    </span>
  );
}
